import _ from "lodash";
import { action, autorun, computed, observable } from "mobx";
import { useLocStore } from "../../localization";
import { LocContext } from "../../localization/LocContext";
import { wsConfirmDialog } from "./wsConfirmDialog";

// legacy unsaved changes handling, only used on /admin and /questionnaire pages
// legacy unsaved changes handling, only used on /admin and /questionnaire pages
// legacy unsaved changes handling, only used on /admin and /questionnaire pages
// legacy unsaved changes handling, only used on /admin and /questionnaire pages
// legacy unsaved changes handling, only used on /admin and /questionnaire pages
// legacy unsaved changes handling, only used on /admin and /questionnaire pages
// legacy unsaved changes handling, only used on /admin and /questionnaire pages
// legacy unsaved changes handling, only used on /admin and /questionnaire pages
// legacy unsaved changes handling, only used on /admin and /questionnaire pages
// legacy unsaved changes handling, only used on /admin and /questionnaire pages
// legacy unsaved changes handling, only used on /admin and /questionnaire pages

export interface UnsavedChangeParams {
  key?: string | number;
  type?: string;
  needsConfirmationBeforeUnload: () => boolean;
  needsConfirmationBeforeSpaRedirect: (newUrl: string, state: any) => boolean;

  /**
   * UnsavedChanges in the front of the queue with
   * identitcal concurrentGroup can all fire at the same time
   */
  concurrentGroup?: string;
}

export interface UnsavedChange extends UnsavedChangeParams {
  key: string | number;
}

let _unsavedChangeKey = 0;
let _uniqueMutationGroupId = 0;

export const unsavedChange = (params: UnsavedChangeParams) => {
  const { key, concurrentGroup, ...rest } = params;

  return {
    key: key ?? ++_unsavedChangeKey,
    concurrentGroup:
      concurrentGroup ?? `uniqueMutationGroup${++_uniqueMutationGroupId}`,
    ...rest,
  };
};

export const _unsavedChanges = observable.array<UnsavedChange>();
export const _unsavedChangesGetters = observable.array<() => UnsavedChange[]>();

export const unsavedChanges = computed(() => {
  const array = [..._unsavedChanges];

  const unsavedChanges = _unsavedChangesGetters.map((g) => g());
  unsavedChanges.forEach((uc) => {
    array.push(...uc);
  });

  return array;
});

export const addUnsavedChange = action((_uc: UnsavedChangeParams) => {
  const uc = unsavedChange(_uc);
  if (!_unsavedChanges.find((x) => x.key === uc.key)) {
    _unsavedChanges.push(uc);
  }

  return action(() => {
    _.remove(_unsavedChanges, (x) => x.key === uc.key);
  });
});

export const addUnsavedChangeGetter = action(
  (getter: () => UnsavedChange[]) => {
    if (!_unsavedChangesGetters.find((x) => x === getter)) {
      _unsavedChangesGetters.push(getter);
    }

    return action(() => {
      _unsavedChangesGetters.remove(getter);
    });
  }
);

export function unsavedChangesDialog(): Promise<boolean | null> {
  return wsConfirmDialog({
    useProps: (props) => {
      const L = useLocStore(LocContext.GENERAL);

      return {
        ...props,
        header: L.id("7d68a9ea1e22").loc("Ulagrede endringer"),
        message: L.id("4bd8ed732d45").loc(
          "Du har ulagrede endringer, er du sikker på at du vil forlate siden?"
        ),
        rejectLabel: L.id("ccb7993376b7").loc("Bli værende"),
        acceptLabel: L.id("7efd3afb6200").loc("Forlat siden"),
      };
    },
  });
}

let beforeUnloadListener;
// (try to) prevent unloading page when there are unsaved changes / mutations pending
autorun(() => {
  const needsConfirmation = unsavedChanges
    .get()
    .filter((uc) => uc.needsConfirmationBeforeUnload());

  const needListener = needsConfirmation.length > 0;

  const hasListener = !!beforeUnloadListener;

  if (needListener && !hasListener) {
    beforeUnloadListener = (event: BeforeUnloadEvent) => {
      if (window.cvpIsLiveReloading) {
        return;
      }

      event.preventDefault();
      return (event.returnValue =
        "Changes may not be saved yet. Are you sure you want to exit?");
    };

    window.addEventListener("beforeunload", beforeUnloadListener, {
      capture: true,
    });
  }

  if (!needListener && hasListener) {
    window.removeEventListener("beforeunload", beforeUnloadListener, {
      capture: true,
    });

    beforeUnloadListener = null;
  }
});
